export default "__VITE_ASSET__PVyKP9Ub__"